export const ALLOW_PATHS = "ALLOW_PATHS";